export interface AssetLoadError {
  hasData: boolean;
  hasServiceError: boolean;
  isRetrying: boolean;
  retry: () => Promise<unknown>;
}

interface QueryState {
  data: unknown;
  isError: boolean;
  isFetching: boolean;
  error: { data?: { httpStatus?: number } | null } | null;
  refetch: () => Promise<unknown>;
}

export function getAssetLoadError(
  query: QueryState,
): AssetLoadError | undefined {
  if (!query.isError) return undefined;

  const status = query.error?.data?.httpStatus;

  return {
    hasData: query.data !== undefined,
    hasServiceError: status === undefined || status >= 500,
    isRetrying: query.isFetching,
    retry: query.refetch,
  };
}
